const cleanFilterData = (filter) => {
  const newFilter = { ...filter };
  newFilter.city = filter.cities.map((city) => city.city_name);
  const values = Object.values(filter);
  const keys = Object.keys(filter);

  for (let i = 0; i < keys.length; i += 1) {
    if (typeof values[i] === 'object') {
      if (values[i] === null) {
        delete newFilter[keys[i]];
      } else if (values[i].length === 0) {
        delete newFilter[keys[i]];
      } else {
        switch (keys[i]) {
        case 'cities':
          newFilter[keys[i]] = filter.cities.map((city) => city.city_name);
          break;
        case 'zone':
          newFilter[keys[i]] = filter.zone.map((zone) => zone.name);
          break;
        case 'stratum':
          newFilter[keys[i]] = filter.stratum.map((zone) => String(zone));
          break;
        case 'price':
          newFilter[keys[i]] = {
            min: filter[keys[i]][0],
            max: filter[keys[i]][1],
          };
          break;
        case 'area':
          newFilter[keys[i]] = {
            min: filter[keys[i]][0],
            max: filter[keys[i]][1],
          };
          break;
        default:
          break;
        }
      }
    }
  }
  return newFilter;
};

export default cleanFilterData;
